import { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/lib/base/buttons/button';
import { sanitizeError } from '@/lib/utils/errors';

import FormErrors, { hasErrors } from '../../components/FormErrors';
import AuthLayout from '../../layouts/AuthLayout';
import { providerSignup } from '../../lib/allauth';
import type { AllauthResponse } from '../../types/allauth';

export default function ProviderSignup() {
  const [email, setEmail] = useState('');
  const [response, setResponse] = useState<{
    fetching: boolean;
    content: AllauthResponse | null;
  }>({ fetching: false, content: null });

  function submit() {
    setResponse({ ...response, fetching: true });
    providerSignup({ email })
      .then(content => {
        setResponse(r => {
          return { ...r, content };
        });
      })
      .catch(e => {
        console.error(e);
        toast.error(sanitizeError(e));
      })
      .then(() => {
        setResponse(r => {
          return { ...r, fetching: false };
        });
      });
  }

  return (
    <AuthLayout title='Sign Up'>
      <p className='my-2 text-fg-secondary'>
        Already have an account?{' '}
        <Link
          to='/account/login'
          className='text-fg-brand-primary hover:text-fg-brand-primary_alt'
        >
          Login here.
        </Link>
      </p>

      <div className='mt-2 w-full'>
        <label className='label font-bold text-fg-primary' htmlFor='email'>
          Email
        </label>
        <input
          type='email'
          id='email'
          className={`input input-bordered w-full bg-bg-primary border-border-primary text-fg-primary focus:border-fg-brand-primary ${
            hasErrors({
              errors: response.content?.errors,
              param: 'email',
            })
              ? 'input-error border-utility-error-300'
              : ''
          }`}
          placeholder='name@example.com'
          required
          onChange={e => setEmail(e.target.value)}
          value={email}
          name='email'
        />
        <FormErrors param='email' errors={response.content?.errors} />
      </div>
      <div className='mt-2'>
        <Button
          type='submit'
          color='primary'
          className='w-full'
          isDisabled={response.fetching}
          onClick={() => submit()}
        >
          Sign up
        </Button>
      </div>
    </AuthLayout>
  );
}
